import styled from "styled-components";

export const NotFounds = styled.div`
    .container{
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        
        .div-image{
            flex:1
            display:flex;

            img{
                width:80vh;
                height:80vh;
            }
        }
    }
`;